import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { WheelOfFortune } from "../../games/WheelOfFortune/WheelOfFortune";
import { GameExitButton } from "./GameExitButton/GameExitButton";
import styles from "./GamePage.module.scss";

export const GamePage = () => {
    return (
        <ContentWrapper full={ true } context='game' >
            <div className={styles.container}>
                <div className={styles.titleBlock}>
                    <h2 className={styles.title}>Колесо Фортуны</h2>
                    <GameExitButton />
                </div>

                <WheelOfFortune />
            </div>
        </ContentWrapper>
    );
}